<template>
  <pt-hospital-form class="pt-hospital-form__page" :isEdit="is_edit"></pt-hospital-form>
</template>

<script>
import PtHospitalForm from 'cps/hospital-and-doctor-manage/pt-hospital-manage/pt-hospital-form'
export default {
  name: 'pt-hospital-form__view',
  components: {
    'pt-hospital-form': PtHospitalForm
  },
  props: {
    isEdit: {
      type: String,
      default: ''
    },
    userLogin: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      is_edit: this.isEdit === 'true'
    }
  }
}
</script>
